var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 31,
    viewBox: "0 0 23 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5002 0.157806C5.49711 0.157806 0.630859 4.9057 0.630859 10.7692C0.630859 16.6327 11.5002 30.6377 11.5002 30.6377C11.5002 30.6377 22.3643 16.6327 22.3643 10.7692C22.3643 4.9057 17.5034 0.157806 11.5002 0.157806ZM11.5002 17.7951C7.52648 17.7951 4.30711 14.6506 4.30711 10.7692C4.30711 6.88788 7.52648 3.74337 11.5002 3.74337C15.474 3.74337 18.6934 6.88788 18.6934 10.7692C18.6934 14.6506 15.474 17.7951 11.5002 17.7951Z",
    fill: "#E82327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMap);
export default __webpack_public_path__ + "static/media/RedMap.83e9b22a538e77b3a7e75395f63bbcda.svg";
export { ForwardRef as ReactComponent };